<script setup lang="ts">
import wallet from '@/assets/icons/black/company.svg'
import editIcon from '@/assets/icons/black/edit.svg'
import checkOutRedIcon from '@/assets/icons/check_out_red.svg'
import { useI18n } from 'vue-i18n'
import CardOptions from '@/components/CardOptions.vue'

const { t } = useI18n()
const { id } = defineProps<{ id: number; isOwner: boolean }>()
const emit = defineEmits(['exit'])
</script>

<template>
  <CardOptions :id="`corporative-account-menu`">
    <v-card elevation="3" class="pa-2" style="z-index: 800">
      <v-layout column class="w-100">
        <!-- Ir para conta corporativa -->
        <RouterLink
          :to="{ name: 'detail-corporative-account', params: { id } }"
          class="d-flex align-center pa-3"
        >
          <v-img
            :src="wallet"
            alt=""
            width="24"
            height="24"
            class="me-2"
            cover
          />
          <span class="font-weight-bold">
            {{ t('profile.corporates.goToCorporativeAccount') }}
          </span>
        </RouterLink>

        <v-divider v-if="isOwner" class="my-2" />

        <!-- Editar conta -->
        <RouterLink
          v-if="isOwner"
          :to="{ name: 'edit-corporative-account', params: { id } }"
          class="d-flex align-center pa-3"
        >
          <v-img
            :src="editIcon"
            alt=""
            width="24"
            height="24"
            class="me-2"
            cover
          />
          <span class="font-weight-bold">
            {{ t('profile.corporates.editCorporativeAccount') }}
          </span>
        </RouterLink>

        <v-divider class="my-2" />

        <!-- Sair -->
        <div
          class="d-flex align-center pa-3 text-error"
          style="cursor: pointer"
          @click="$emit('exit')"
        >
          <v-img
            :src="checkOutRedIcon"
            alt=""
            width="24"
            height="24"
            class="me-2"
            cover
          />
          <span class="font-weight-bold">
            {{ t('profile.corporates.exit') }}
          </span>
        </div>
      </v-layout>
    </v-card>
  </CardOptions>
</template>
